import React from 'react'
import styled from 'styled-components'

interface PropsType {
    children: React.ReactNode; // Define the children prop
}
const PaymentFiels: React.FC<PropsType> = (props) => {
    return (
        <Root>
            {props.children}
        </Root>
    )
}
export default PaymentFiels;
const Root = styled.div`
  position: relative;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  padding: clamp(2.5rem, 5vw, 4rem) clamp(2rem, 5vw, 3.5rem);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: 'Gilroy-Regular', 'Gilroy', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
    border-color: #d1d5db;
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  .field_name,
  .title {
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
    font-size: clamp(1.75rem, 4vw, 2.25rem);
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.75rem;
    line-height: 1.2;
    letter-spacing: -0.025em;
    text-align: center;
  }

  .sr_number {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 2rem;

    span {
      background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
      color: white;
      padding: 0.5rem 0.75rem;
      border-radius: 8px;
      font-size: 1rem;
      font-weight: 600;
      min-width: 2rem;
      text-align: center;
      box-shadow: 0 2px 4px -1px rgba(59, 130, 246, 0.5);

      @media (max-width: 768px) {
        font-size: 0.875rem;
        padding: 0.375rem 0.625rem;
      }
    }

    .text_danger {
      color: #ef4444;
      font-size: 1.25rem;
      font-weight: 600;
      margin-left: 0.5rem;
    }
  }

  .discription {
    font-size: 1.125rem;
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 2rem;
    background: transparent;
    border: none;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 1.5rem;
    }
  }

  .payment_amount {
    font-family: 'Gilroy-Heavy', 'Gilroy-Bold', 'Gilroy', sans-serif;
    font-size: clamp(2.5rem, 6vw, 4rem);
    font-weight: 800;
    color: #059669;
    margin: 1.5rem 0;
    text-shadow: 0 2px 4px rgba(5, 150, 105, 0.1);
    letter-spacing: -0.025em;

    @media (max-width: 768px) {
      margin: 1rem 0;
    }
  }

  .pay_btn {
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
    color: white;
    font-size: 1.25rem;
    font-weight: 700;
    padding: 1rem 2.5rem;
    border-radius: 16px;
    border: none;
    cursor: pointer;
    margin: 2rem 0;
    min-width: 200px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 8px -2px rgba(5, 150, 105, 0.5);

    &:hover {
      background: linear-gradient(135deg, #047857 0%, #065f46 100%);
      transform: translateY(-2px);
      box-shadow: 0 8px 16px -4px rgba(5, 150, 105, 0.5);
    }

    &:active {
      transform: translateY(0);
    }

    &:disabled {
      background: #cbd5e1;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }

    @media (max-width: 768px) {
      font-size: 1.125rem;
      padding: 0.875rem 2rem;
      min-width: 180px;
      margin: 1.5rem 0;
    }
  }

  .payment_link {
    font-size: 1.5rem;
    font-weight: 600;
    color: #3b82f6;
    margin-top: 1.5rem;
    word-break: break-all;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 12px;
    border: 2px solid #e2e8f0;

    @media (max-width: 768px) {
      font-size: 1.25rem;
      margin-top: 1rem;
      padding: 0.75rem;
    }
  }

  .input_box {
    padding: 0.75rem 1.25rem;
    font-size: 1.125rem;
    color: #1e293b;
    background: white;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    margin: 1rem 0;
    min-width: 120px;
    text-align: center;
    font-family: inherit;
    font-weight: 600;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:focus {
      outline: none;
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &::placeholder {
      color: #94a3b8;
    }

    @media (max-width: 768px) {
      font-size: 1rem;
      padding: 0.625rem 1rem;
    }
  }

  .delete_btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #dc2626;
    padding: 0.5rem;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    width: auto;
    height: auto;

    &:hover {
      background: #fee2e2;
      border-color: #fca5a5;
      transform: scale(1.05);
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;